import { type IPackages } from "@kunduz/data-access-payment-api";
import { cancelStudentSubscriptionBuilder } from "./cancelStudentSubscription";
import { getCancellationReasonsBuilder } from "./getCancellationReasons";
import { getCommunicationPreferencesBuilder } from "./getCommunicationPreferences";
import { getGradesBuilder } from "./getGrades";
import { getStudentMeBuilder } from "./getStudentMe";
import { getStudentPackagesBuilder } from "./getStudentPackages";
import { type ICore } from "./interfaces";
import { getCoreApiNetworkClient } from "./networkClient";
import { getSaveCommunicationPreferencesBuilder } from "./saveCommunicationPreferences";
import { getUpdateCommunicationPreferencesBuilder } from "./updateCommunicationPreferences";
import { getUsersAddressesBuilder } from "./getUsersAddresses";
import { saveUserAddressBuilder } from "./saveUserAddress";
import { updateUserAddressBuilder } from "./updateUserAddress";
import { getUserShipmentsBuilder } from "./getUsersShipments";
import { approveUserAddressBuilder } from "./approveUserAddress";
import { askQuestionBuilder } from "./askQuestion";

export function getCoreApiClientFunctions(options?: {
  token?: string;
}): IKunduzCoreApiClient {
  const apiClient = getCoreApiNetworkClient({
    token: options?.token,
  });

  const functions = {
    getStudentMe: getStudentMeBuilder(apiClient),
    cancelStudentSubscription: cancelStudentSubscriptionBuilder(apiClient),
    getCommunicationPreferences: getCommunicationPreferencesBuilder(apiClient),
    saveCommunicationPreferences:
      getSaveCommunicationPreferencesBuilder(apiClient),
    updateCommunicationPreferences:
      getUpdateCommunicationPreferencesBuilder(apiClient),
    getGrades: getGradesBuilder(apiClient),
    getCancellationReasons: getCancellationReasonsBuilder(apiClient),
    getStudentPackages: getStudentPackagesBuilder(apiClient),
    getUsersAddresses: getUsersAddressesBuilder(apiClient),
    saveUserAddress: saveUserAddressBuilder(apiClient),
    updateUserAddress: updateUserAddressBuilder(apiClient),
    getUserShipments: getUserShipmentsBuilder(apiClient),
    approveUserAddress: approveUserAddressBuilder(apiClient),
    askQuestion: askQuestionBuilder(apiClient),
  };

  return functions;
}
interface IKunduzCoreApiClient {
  getStudentMe: () => Promise<ICore.IStudentV4 | undefined>;
  cancelStudentSubscription: (
    subscriptionId: any,
    reason: any,
  ) => Promise<void>;
  getCommunicationPreferences: () => Promise<ICore.ICommPermission[]>;
  saveCommunicationPreferences: (
    key: ICore.CommunicationPermissionTypes,
    value: string | number | boolean,
  ) => Promise<ICore.ICommPermission>;
  updateCommunicationPreferences: (
    id: number,
    value: string | number | boolean,
  ) => Promise<ICore.ICommPermission>;
  getGrades: (iso: string) => Promise<ICore.IGrade[]>;
  getCancellationReasons: () => Promise<ICore.CancellationReason[]>;
  getStudentPackages: () => Promise<IPackages.IPaymentResponse[]>;
  getUsersAddresses: () => Promise<ICore.UserAddress[]>;
  saveUserAddress: (payload: ICore.SaveAddressRequestDto) => Promise<any>;
  updateUserAddress: (addresId: string, payload: any) => Promise<any>;
  getUserShipments: () => Promise<ICore.BookShipment[]>;
  approveUserAddress: (
    shipmentId: number,
    payload: ICore.ConfirmShippingAddressRequest,
  ) => Promise<any>;
  askQuestion: (payload: {
    course: number;
    media_url: string;
    selected_option: any;
    text: string;
  }) => Promise<any>;
}
